/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_SignInputs */

const en_statement_taxonomy_editor_sign = /** @type {(inputs: Statement_Taxonomy_Editor_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign`)
};

const nl_statement_taxonomy_editor_sign = /** @type {(inputs: Statement_Taxonomy_Editor_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teken`)
};

/**
* | output |
* | --- |
* | "Sign" |
*
* @param {Statement_Taxonomy_Editor_SignInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_sign = /** @type {((inputs?: Statement_Taxonomy_Editor_SignInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_SignInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_sign(inputs)
	return en_statement_taxonomy_editor_sign(inputs)
});